import { useState } from "react";
import { tickerItems } from "@/mocks/scandal";

const navLinks = [
  { label: "全时间线", to: "#timeline" },
  { label: "当事人回应", to: "#response" },
  { label: "话题墙", to: "#topics" },
  { label: "归档资源", to: "#archive" },
  { label: "网友讨论", to: "#discuss" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loop = [...tickerItems, ...tickerItems];

  return (
    <header className="sticky top-0 z-50">
      {/* 更新条压顶 */}
      <div className="bg-primary-600 text-background-50">
        <div className="relative flex items-center overflow-hidden">
          <div className="relative z-10 flex shrink-0 items-center gap-2 bg-primary-600 px-3 md:px-5 py-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-300 animate-pulse-dot" />
            <span className="font-label text-[11px] md:text-xs font-bold tracking-wide">滚动更新</span>
          </div>
          <div className="relative flex flex-1 items-center overflow-hidden pl-2">
            <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
              {loop.map((item, i) => (
                <span key={i} className="text-[11px] md:text-xs leading-relaxed opacity-90">
                  {item}
                </span>
              ))}
            </div>
          </div>
          <a
            href="#timeline"
            className="relative z-10 hidden shrink-0 items-center gap-1.5 bg-primary-700 px-4 py-1.5 text-xs font-bold whitespace-nowrap hover:bg-primary-800 sm:flex"
          >
            追最新
            <i className="ri-arrow-right-up-line" />
          </a>
        </div>
      </div>

      {/* 品牌导航 */}
      <div className="border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
        <div className="flex items-center justify-between gap-4 px-4 md:px-6 py-3">
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-fire-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <h1 className="font-heading text-xl md:text-2xl font-black tracking-tight text-primary-700">
                抖音黑料
              </h1>
              <span className="mt-1 text-[10px] font-medium tracking-widest text-foreground-400">
                时间线 · 全记录档案库
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-7 lg:flex">
            {navLinks.map((n) => (
              <a
                key={n.to}
                href={n.to}
                className="text-sm font-medium text-foreground-600 whitespace-nowrap transition-colors hover:text-primary-600"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#timeline"
              className="hidden items-center gap-1.5 rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-700 md:flex"
            >
              进入全时间线
              <i className="ri-arrow-right-line text-sm" />
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 lg:hidden"
            >
              <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-3-line"}`} />
            </button>
          </div>
        </div>

        {/* 移动端菜单 */}
        {open && (
          <nav className="border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden">
            <div className="flex flex-col gap-1">
              {navLinks.map((n) => (
                <a
                  key={n.to}
                  href={n.to}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100"
                >
                  {n.label}
                </a>
              ))}
              <a
                href="#timeline"
                onClick={() => setOpen(false)}
                className="mt-2 flex items-center justify-center gap-1.5 rounded-md bg-primary-600 px-4 py-2.5 text-sm font-semibold text-background-50"
              >
                进入全时间线
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}